import { get } from 'lodash';
import { connect } from 'react-redux';
import { BLOG_APP_ID, SANTA_MEMBERS_APP_ID } from '../../constants/applications';
import forUserPrivacyType from '../../../app/hoc/for-user-privacy-type';
import ExternalLink from '../../components/link/external-link';
import InternalLink from '../../components/link/internal-link';
import NoopLink from '../../components/link/noop-link';
import MembersAreaLink from '../../components/link/members-area-link';
import { navigateToBlog, navigateToForum } from '../../services/navigate-to-section';
import Wix from '../../services/wix-sdk-polyfill';

const MEMBERS_SECTION_APP_ID = '14dbefd2-01b4-fb61-32a7-3abd44da4908';
const SETTINGS_SECTION_APP_ID = '14f25dc5-6af3-5420-9568-f9c5ed98c9b1';
const NOTIFICATIONS_SECTION_APP_ID = '14f25924-5664-31b2-9568-f9c5ed98c9b1';

export default {
  Link: InternalLink,
  MembersLink: connect(() => ({
    appDefinitionId: MEMBERS_SECTION_APP_ID,
    sectionId: 'all_members',
    to: '/',
    renderHref: false,
  }))(ExternalLink),
  ProfileLink: connect(undefined, (dispatch, { user }) => ({
    onClick: event => {
      event.preventDefault();
      event.stopPropagation();

      Wix.getPublicAPI({ appDefinitionId: SANTA_MEMBERS_APP_ID }, api => {
        api.navigateToMember({
          memberId: get(user, 'siteMemberId'),
        }, console.error);
      }, console.error);
    },
  }))(forUserPrivacyType(MembersAreaLink)),
  FollowingLink: NoopLink,
  FollowersLink: NoopLink,
  SettingsLink: connect(() => ({
    appDefinitionId: SETTINGS_SECTION_APP_ID,
    sectionId: 'settings',
    to: '/',
    renderHref: false,
  }))(ExternalLink),
  NotificationsLink: connect(() => ({
    appDefinitionId: NOTIFICATIONS_SECTION_APP_ID,
    sectionId: 'notifications',
    to: '/',
    renderHref: false,
  }))(ExternalLink),
  navigateToMembers: () => Wix.Utils.navigateToSection({
    appDefinitionId: MEMBERS_SECTION_APP_ID,
    sectionId: 'all_members',
    shouldRefreshIframe: false,
  }, ''),
  navigateToProfile: user => Wix.getPublicAPI({ appDefinitionId: SANTA_MEMBERS_APP_ID }, api => {
    api.navigateToMember({
      memberId: get(user, 'siteMemberId'),
    }, console.error);
  }, console.error),
  navigateToProfileSettings: () => Wix.Utils.navigateToSection({
    appDefinitionId: SETTINGS_SECTION_APP_ID,
    sectionId: 'settings',
    shouldRefreshIframe: false,
  }, ''),
  navigateToNotifications: () => Wix.Utils.navigateToSection({
    appDefinitionId: NOTIFICATIONS_SECTION_APP_ID,
    sectionId: 'notifications',
    shouldRefreshIframe: false,
  }, ''),
  navigateToEditPost: location => navigateToForum(location),
  navigateToCreatePost: () => navigateToBlog('/create-post'),
  navigateToMyDrafts: user => Wix.getPublicAPI({ appDefinitionId: SANTA_MEMBERS_APP_ID }, api => {
    api.navigateToSection({
      appDefinitionId: BLOG_APP_ID,
      appPageId: 'member-drafts-page',
      viewedUser: get(user, 'siteMemberId'),
    }, console.error);
  }, console.error),
};



// WEBPACK FOOTER //
// ./app/services/navigation-provider/forum-with-members-area.js